<template>
  <div>
    <div class="title">
      <h1 data-testid="product-title">{{ product.title }}</h1>
      <discount-infobox v-if="!!discount" :text="discount.description" />
    </div>

    <div class="back-wrapper">
      <BackButton class="back-link" />
    </div>

    <form class="form products">
      <fieldset class="form__fieldset">
        <div
          class="products__wrapper"
          :data-option-count="product.options.length"
        >
          <Product
            v-for="option in product.options"
            :key="option.code"
            :product="product.type"
            :option="option"
            :selected="product.selected === option.code"
            :selectedPrice="selectedPrice"
            :show-price="product.showPrices"
            :show-radio="shouldShowRadio"
            @option-selected="updateSelected"
            @price-changed="priceChanged"
          />
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
import Product from "@/components/Product";
import DiscountInfobox from "@/components/DiscountInfobox";

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    discount: {
      type: Object,
      required: false,
    },
  },
  computed: {
    selectedPrice() {
      const selectedProduct = this.product.options.find(
        (option) => this.product.selected === option.code,
      );

      return selectedProduct.price.current;
    },
    shouldShowRadio() {
      return this.product.options.length > 1;
    },
  },
  methods: {
    updateSelected(code) {
      this.$store.commit("SET_PRODUCT_OPTION", {
        type: this.product.type,
        code: code,
      });
    },
    priceChanged(price) {
      this.$emit("price-changed", price);
    },
  },
  components: {
    DiscountInfobox,
    Product,
  },
};
</script>

<style lang="scss" scoped>
.back-wrapper {
  max-width: 77rem;
  margin: 0 auto;
}

.title {
  text-align: center;
  margin: 5rem 0 $spacing-medium 0;

  h1 {
    margin: 0;
  }

  .discount-infobox {
    margin-top: 1rem;
  }
}

.products__wrapper {
  &[data-option-count="1"] {
    @include media(">=medium") {
      justify-content: space-around;

      .product-option {
        max-width: min(100%, 55rem);
      }
    }
  }

  @include media(">=medium") {
    display: flex;
    align-items: stretch;
    margin: 0 -5px;
  }
}
</style>
